export default __webpack_public_path__ + "static/media/tensorflow.8fdee995.svg";